export const COUNTRIES = [
    { code: 'united_states', name: 'United States', flag: '🇺🇸' },
    { code: 'india', name: 'India', flag: '🇮🇳' },
    { code: 'united_kingdom', name: 'United Kingdom', flag: '🇬🇧' },
    { code: 'canada', name: 'Canada', flag: '🇨🇦' },
    { code: 'australia', name: 'Australia', flag: '🇦🇺' },
    { code: 'brazil', name: 'Brazil', flag: '🇧🇷' },
    { code: 'germany', name: 'Germany', flag: '🇩🇪' },
    { code: 'france', name: 'France', flag: '🇫🇷' },
    { code: 'japan', name: 'Japan', flag: '🇯🇵' },
];

export const PLATFORMS = [
    { code: 'web', name: 'Google Search', icon: '🔍' },
    { code: 'youtube', name: 'YouTube', icon: '📺' },
    { code: 'instagram', name: 'Instagram', icon: '📸' },
    { code: 'facebook', name: 'Facebook', icon: '👥' },
];
